import { render, staticRenderFns } from "./CopyStakeWebStreamersTable.vue?vue&type=template&id=5fd807d2&scoped=true&lang=pug"
import script from "./CopyStakeWebStreamersTable.vue?vue&type=script&lang=ts"
export * from "./CopyStakeWebStreamersTable.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeWebStreamersTable.vue?vue&type=style&index=0&id=5fd807d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd807d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VSwitch,VTooltip})
